import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import permissionService from '../services/permissionService';

const initialPermissions = {
    canCreateUsers: false, canEditUsers: false, canDeleteUsers: false,
    canEditRules: false, canDeployRules: false, canDeleteRules: false,
    canAssignCases: false, canManageMasters: false, isAdmin: false,
};

export const usePermissions = () => {
    const { user } = useAuth();
    const [permissions, setPermissions] = useState(initialPermissions);
    const [isLoading, setIsLoading] = useState(true); // Add a loading state, default to true

    useEffect(() => {
        const checkPermissions = async () => {
            setIsLoading(true); // Start loading when user changes
            if (!user) {
                setPermissions(initialPermissions);
                setIsLoading(false); // Stop loading if no user
                return;
            }

            const [
                canCreateUsers, canEditUsers, canDeleteUsers,
                canEditRules, canDeployRules, canDeleteRules,
                canAssignCases, canManageMasters
            ] = await Promise.all([
                permissionService.can(user, 'canCreateUsers'),
                permissionService.can(user, 'canEditUsers'),
                permissionService.can(user, 'canDeleteUsers'),
                permissionService.can(user, 'canEditRulesInSandbox'),
                permissionService.can(user, 'canDeployRules'),
                permissionService.can(user, 'canDeleteRules'),
                permissionService.can(user, 'canAssignCases'),
                permissionService.can(user, 'canManageMasters'),
            ]);

            setPermissions({
                canCreateUsers, canEditUsers, canDeleteUsers,
                canEditRules, canDeployRules, canDeleteRules,
                canAssignCases, canManageMasters,
                isAdmin: user.role === 'L3 Admin',
            });
            
            setIsLoading(false); // Stop loading after permissions are fetched
        };

        checkPermissions();
    }, [user]);

    // Return both the permissions and the loading state
    return { permissions, isLoading };
};